import React from 'react';
import { ArrowUp, ArrowDown, Plus } from 'lucide-react';

const AdminDashboard: React.FC = () => {
    return (
        <>
            {/* Breadcrumbs */}
            <div className="flex flex-wrap gap-2">
                <span className="text-[#6B7280] dark:text-[#9CA3AF] text-sm font-medium leading-normal">Home</span>
                <span className="text-[#6B7280] dark:text-[#9CA3AF] text-sm font-medium leading-normal">/</span>
                <span className="text-[#374151] dark:text-[#E5E7EB] text-sm font-medium leading-normal">Dashboard</span>
            </div>
            {/* PageHeading */}
            <div className="flex flex-wrap justify-between gap-3 items-center">
                <div className="flex min-w-72 flex-col gap-1">
                    <p className="text-[#374151] dark:text-[#E5E7EB] text-3xl font-bold leading-tight tracking-tight">Dashboard</p>
                    <p className="text-[#6B7280] dark:text-[#9CA3AF] text-base font-normal leading-normal">Visão geral do sistema e métricas de desempenho.</p>
                </div>
                <button className="flex items-center justify-center gap-2 h-10 px-4 bg-[#2563EB] text-white rounded-lg text-sm font-medium hover:bg-[#2563EB]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#F8F9FA] dark:focus:ring-offset-[#1F2937] focus:ring-[#2563EB]">
                    <Plus className="size-5" />
                    <span>Novo Relatório</span>
                </button>
            </div>
            {/* Stats */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#111827] border border-[#E5E7EB] dark:border-[#374151]">
                    <p className="text-[#6B7280] dark:text-[#9CA3AF] text-sm font-medium leading-normal">Total de Usuários</p>
                    <div className="flex justify-between items-baseline">
                        <p className="text-[#374151] dark:text-[#E5E7EB] tracking-tight text-3xl font-bold leading-tight">1,482</p>
                        <p className="text-[#10B981] text-sm font-semibold leading-normal flex items-center gap-1">
                            <ArrowUp className="size-4" />
                            <span>+2.5%</span>
                        </p>
                    </div>
                </div>
                <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#111827] border border-[#E5E7EB] dark:border-[#374151]">
                    <p className="text-[#6B7280] dark:text-[#9CA3AF] text-sm font-medium leading-normal">Projetos Ativos</p>
                    <div className="flex justify-between items-baseline">
                        <p className="text-[#374151] dark:text-[#E5E7EB] tracking-tight text-3xl font-bold leading-tight">89</p>
                        <p className="text-[#EF4444] text-sm font-semibold leading-normal flex items-center gap-1">
                            <ArrowDown className="size-4" />
                            <span>-1.2%</span>
                        </p>
                    </div>
                </div>
                <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#111827] border border-[#E5E7EB] dark:border-[#374151]">
                    <p className="text-[#6B7280] dark:text-[#9CA3AF] text-sm font-medium leading-normal">Uso da API (24h)</p>
                    <div className="flex justify-between items-baseline">
                        <p className="text-[#374151] dark:text-[#E5E7EB] tracking-tight text-3xl font-bold leading-tight">25.4k</p>
                        <p className="text-[#10B981] text-sm font-semibold leading-normal flex items-center gap-1">
                            <ArrowUp className="size-4" />
                            <span>+15%</span>
                        </p>
                    </div>
                </div>
                <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#111827] border border-[#E5E7EB] dark:border-[#374151]">
                    <p className="text-[#6B7280] dark:text-[#9CA3AF] text-sm font-medium leading-normal">Assinaturas Ativas</p>
                    <div className="flex justify-between items-baseline">
                        <p className="text-[#374151] dark:text-[#E5E7EB] tracking-tight text-3xl font-bold leading-tight">1,201</p>
                        <p className="text-[#10B981] text-sm font-semibold leading-normal flex items-center gap-1">
                            <ArrowUp className="size-4" />
                            <span>+5.0%</span>
                        </p>
                    </div>
                </div>
            </div>
            {/* Recent Users Table */}
            <div className="bg-white dark:bg-[#111827] border border-[#E5E7EB] dark:border-[#374151] rounded-xl">
                <div className="p-4 border-b border-[#E5E7EB] dark:border-[#374151]">
                    <h3 className="text-lg font-semibold text-[#374151] dark:text-[#E5E7EB]">Novos Usuários</h3>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="text-xs text-[#6B7280] dark:text-[#9CA3AF] uppercase bg-[#F8F9FA] dark:bg-[#1F2937]">
                            <tr>
                                <th className="px-6 py-3" scope="col">Nome</th>
                                <th className="px-6 py-3" scope="col">Plano</th>
                                <th className="px-6 py-3" scope="col">Data de Registro</th>
                                <th className="px-6 py-3" scope="col">Status</th>
                                <th className="px-6 py-3 text-right" scope="col">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b border-[#E5E7EB] dark:border-[#374151]">
                                <td className="px-6 py-4 font-medium text-[#374151] dark:text-[#E5E7EB] whitespace-nowrap">Ana Oliveira</td>
                                <td className="px-6 py-4">Profissional</td>
                                <td className="px-6 py-4">2023-10-26</td>
                                <td className="px-6 py-4"><span className="px-2 py-1 text-xs font-medium rounded-full bg-[#10B981]/20 text-[#10B981]">Ativo</span></td>
                                <td className="px-6 py-4 text-right">
                                    <a className="font-medium text-[#2563EB] hover:underline" href="#">Ver</a>
                                </td>
                            </tr>
                            <tr className="border-b border-[#E5E7EB] dark:border-[#374151]">
                                <td className="px-6 py-4 font-medium text-[#374151] dark:text-[#E5E7EB] whitespace-nowrap">Bruno Costa</td>
                                <td className="px-6 py-4">Básico</td>
                                <td className="px-6 py-4">2023-10-25</td>
                                <td className="px-6 py-4"><span className="px-2 py-1 text-xs font-medium rounded-full bg-[#10B981]/20 text-[#10B981]">Ativo</span></td>
                                <td className="px-6 py-4 text-right">
                                    <a className="font-medium text-[#2563EB] hover:underline" href="#">Ver</a>
                                </td>
                            </tr>
                            <tr className="border-b border-[#E5E7EB] dark:border-[#374151]">
                                <td className="px-6 py-4 font-medium text-[#374151] dark:text-[#E5E7EB] whitespace-nowrap">Carlos Dias</td>
                                <td className="px-6 py-4">Enterprise</td>
                                <td className="px-6 py-4">2023-10-24</td>
                                <td className="px-6 py-4"><span className="px-2 py-1 text-xs font-medium rounded-full bg-[#F59E0B]/20 text-[#F59E0B]">Pendente</span></td>
                                <td className="px-6 py-4 text-right">
                                    <a className="font-medium text-[#2563EB] hover:underline" href="#">Ver</a>
                                </td>
                            </tr>
                            <tr>
                                <td className="px-6 py-4 font-medium text-[#374151] dark:text-[#E5E7EB] whitespace-nowrap">Daniela Souza</td>
                                <td className="px-6 py-4">Profissional</td>
                                <td className="px-6 py-4">2023-10-23</td>
                                <td className="px-6 py-4"><span className="px-2 py-1 text-xs font-medium rounded-full bg-[#EF4444]/20 text-[#EF4444]">Suspenso</span></td>
                                <td className="px-6 py-4 text-right">
                                    <a className="font-medium text-[#2563EB] hover:underline" href="#">Ver</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="p-4 text-center">
                    <a className="text-sm font-medium text-[#2563EB] hover:underline" href="#">Ver todos os usuários</a>
                </div>
            </div>
        </>
    );
};

export default AdminDashboard;
